import enLocale from 'element-ui/lib/locale/lang/en';

let dictionary = {
    ...enLocale,
    errorCodes: {
        NOT_FOUND_HTTP_EXCEPTION: 'Requested resource is not found',
        INVALID_CREDENTIALS: 'Invalid Credentials',
        UNKNOWN_PARAMETER: 'Requested data with unknown parameter',
    },
    validation: {
        messages: {
            required: () => {
                return 'Required';
            },
            email: () => {
                return 'This is not a valid email';
            },
            confirmed: () => {
                return 'Confirmation does not match';
            },
        },
    },
    list: {
        noDataMessage: 'No data',
        loadingError: 'Data loading failed. Please try again using Refresh button.',
        refresh: 'Refresh',
        noPreviewAvailable: 'No Preview Available',
    },
    analytics: {
        dimensionTooltip: 'Filter',
        other: 'Other',
    },
    dashboard: {
        moreOffers: 'More offers',
    },
    profileDetails: {
        missingInfo: 'Add missing info',
        euVatTooltip: 'Set VAT Rate to 0% and mark this for Reverse Charge procedure',
        currency: {
            change: 'Change',
            modal: {
                title: 'Change currency',
                onlyOnceInfo: 'The currency can be changed only once.',
            },
        },
    },
    verify: {
        info: 'Thank you for verifying your e-mail address. We will get back to you shortly, once your account has been reviewed.',
        error: 'Invalid URL params',
    },
    loggedOut: 'Logged Out',
    accountSuspended: 'Your account is suspended',
    sessionExpired: {
        title: 'Session expired',
        message: 'Your session was expired. To continue, please log in again.',
        buttonText: 'Click here to login',
    },
};

// Override Element UI dictionary
dictionary.el.pagination = {
    ...enLocale.el.pagination,
    total: 'Total: {total}',
};

export default dictionary;
